import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { State } from "../../../redux/slices";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { MenuEditLocation } from "./EditLocation";
import LinkUsersToLocation from "../../grainWise/edit/LinkUsersToLocation";
import { logoutGrainTrackerE } from "../../../redux/slices/grainTracker/grainTrackerEdition";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    resetEditLocationValues: () => {
      dispatch(logoutGrainTrackerE());
    },
  };
};

const LinkUsersToLocations: FC<any> = () => {
  const [t] = useTranslation("global");
  const { resetEditLocationValues } = SetActions();

  const {
    locationSelectedIs,
    selectedLocation,
    isCreatingWithGrainTracker,
    locationGrainTrackerValues,
  } = useSelector((state: State) => state.GrainWiseEditionReducer);

  const navigate = useNavigate();

  window.onunload = function (e) {
    e.preventDefault();
  };

  useEffect(() => {
    if (!selectedLocation.values.id) {
      navigate("/locations");
    }
  }, []);

  return (
    <div className="create-sites-container">
      {MenuEditLocation(
        locationSelectedIs.EditingValues,
        locationSelectedIs.EditingStockage,
        t,
        navigate,
        resetEditLocationValues,
        selectedLocation,
      )}

      {
        <LinkUsersToLocation
          isCreatingWithGrainTracker={isCreatingWithGrainTracker}
          locationGrainTrackerValues={locationGrainTrackerValues}
          logOutGrainTracker={logoutGrainTrackerE}
        />
      }
    </div>
  );
};

export default LinkUsersToLocations;
